import { VISITOR_ID_COOKIE_KEY, VISITOR_ID_COOKIE_MAX_AGE_SECONDS } from './visitor-id-cookie-key';

function readCookie(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${VISITOR_ID_COOKIE_KEY}=`));
  if (!match) {
    return null;
  }
  return decodeURIComponent(match.split('=')[1] ?? '') || null;
}

function writeCookie(visitorId: string): void {
  if (typeof document === 'undefined') {
    return;
  }
  const isHttps = window.location.protocol === 'https:';
  const secureFlag = isHttps ? '; Secure' : '';
  // biome-ignore lint/suspicious/noDocumentCookie: client-side visitor id needs persistence before any auth
  document.cookie = `${VISITOR_ID_COOKIE_KEY}=${encodeURIComponent(visitorId)}; Max-Age=${VISITOR_ID_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureFlag}`;
}

export function getOrCreateVisitorId(): string {
  const existing = readCookie();
  if (existing) {
    return existing;
  }
  const fresh = crypto.randomUUID();
  writeCookie(fresh);
  return fresh;
}
